import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@cmps/ng-bootstrap';
import { Subscription } from 'rxjs';

import { WidgetConfiguration } from '../widget/config.widget.model';
import { datesForDateRange } from '../widget/date-range.widget.model';
import { ModalWidgetComponent } from '../widget/modal.widget.component';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';
import { WidgetService } from '../widget/widget.service';

import {
    DualChartPerformanceComparison,
    DualChartPerformanceComparisonPillar,
} from './dual-chart-performance-comparison.widget.model';
import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { PillarPerformanceWidgetComponent } from './pillar-performance.widget.component';
import { TdbfgComplianceWidgetComponent } from './tdbfg-compliance.widget.component';

@Component({
    selector: 'cmps-widget-dual-chart-performance-comparison',
    templateUrl: './dual-chart-performance-comparison.widget.component.html',
})
export class DualChartPerformanceComparisonWidgetComponent
    implements OnInit, OnDestroy
{
    i18n = TranslationKeyMap;
    private _sub: Subscription;
    hasPendingData: boolean;
    dateRange: Date[];
    data: DualChartPerformanceComparison[];
    private _modal: NgbModalRef;

    // TODO revise
    private _showGoToDashboardButton: boolean;
    private _kpiIds: number[];
    private _isTd: boolean;

    constructor(
        private readonly _modalService: NgbModal,
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _widgetService: WidgetService,
        private readonly _service: LegacyWidgetService,
    ) {
        this._evalAttributes();
    }

    ngOnInit(): void {
        this._sub = this._widgetService.dateRange.subscribe((dateRange) => {
            this.data = null;
            if (!dateRange) {
                console.error('invalid date range');
                return;
            }
            this.dateRange = datesForDateRange(dateRange);
            this.hasPendingData = true;
            this._service
                .dualChartPerformanceComparison(this.config.definitionId)
                // eslint-disable-next-line no-return-assign
                .subscribe(
                    (data) => (this.data = data),
                    // eslint-disable-next-line n/handle-callback-err, no-return-assign
                    (error) => (this.hasPendingData = false),
                    // eslint-disable-next-line no-return-assign
                    () => (this.hasPendingData = false),
                );
        });
    }

    ngOnDestroy(): void {
        if (this._modal) {
            this._modal.close();
        }
        if (this._sub) {
            this._sub.unsubscribe();
        }
    }

    // TODO revise
    private _evalAttributes(): void {
        this._kpiIds = [];
        this.config.attributes
            .filter((attr) => attr.name)
            .map((attr) => {
                attr.name = attr.name.toLowerCase();
                return attr;
            })
            .forEach((attr) => {
                // if (attr.name === 'displayallpillars')
                // if (attr.name === 'displayvariance')
                // if (attr.name === 'format')
                // if (attr.name === 'includeqtr')
                // if (attr.name === 'includesg')
                // if (attr.name === 'showdateselector')
                if (attr.name === 'showgotodashboardbutton')
                    this._showGoToDashboardButton =
                        attr.value !== '0' &&
                        attr.value.toLowerCase() !== 'false';
                // if (attr.name === 'timeframe')
                if (attr.name.startsWith('kpiid')) {
                    if (attr.value == null || attr.value.length === 0) return;
                    this._kpiIds.push(parseInt(attr.value));
                }
                // TODO revise
                if (attr.name === 'istdipopup')
                    this._isTd =
                        attr.value !== '0' &&
                        attr.value.toLowerCase() !== 'false';
            });
    }

    onPieBarClick($event): void {
        this._showDetails($event.pillar);
    }

    private _showDetails(pillar: DualChartPerformanceComparisonPillar): void {
        this._modal = this._modalService.open(ModalWidgetComponent, {
            windowClass:
                'cmps-widget-dual-chart-performance-comparison-modal-window',
        });
        this._modal.componentInstance.config = {
            header: this.config.title,
            component: !this._isTd
                ? PillarPerformanceWidgetComponent
                : TdbfgComplianceWidgetComponent,
            options: {
                hasDetails: this._showGoToDashboardButton,
                definitionId: this.config.definitionId,
                pillarIds: this._kpiIds,
                pillar,
                pillarIndex: this.data.findIndex(
                    (item) => item.piePillar === pillar,
                ),
            },
        };
        // eslint-disable-next-line no-return-assign
        this._modal.result.then(
            (result) => (this._modal = null),
            (reason) => (this._modal = null),
        );
    }
}
